import { Stack, Typography, useTheme } from "@mui/material";
import { Info } from "lucide-react";
import type { FC } from "react";

type Props = {
	text: string;
	isLast?: boolean;
};

export const FlatRowHint: FC<Props> = ({ text, isLast }) => {
	const theme = useTheme();

	return (
		<Stack
			direction="row"
			alignItems="flex-start"
			gap={1}
			px={theme.spacingTokens.lg}
			py={1.25} // no matching spacing token
			borderBottom={
				isLast ? "none" : `1px solid ${theme.palette.surface.border}`
			}
		>
			<Info
				size={theme.iconSize.sm}
				color={theme.palette.grey[400]}
				style={{ marginTop: 2, flexShrink: 0 }}
			/>
			<Typography variant="caption" color={theme.palette.grey[500]}>
				{text}
			</Typography>
		</Stack>
	);
};
